/*!
 * kb-quickview.js — v8.9.16.4
 * ============================================================================
 * v8.9.16.4 changes:
 *  - Price area now shows " - Get N free swatches" in red while under threshold
 *  - Multi-select checkbox dropdown: shows color names, bi-directional sync
 *    with chip grid (click chip OR checkbox to toggle selection)
 */
(function () {
  'use strict';

  var MODAL_ID = 'kb-quickview-modal';
  var modalEl = null;
  var lastTrigger = null;
  var currentProduct = null;
  var lastClickedVariant = null;
  var selectedVariantIds = [];
  var underThreshold = false;
  var thresholdValue = 3;
  var cartEligibleCount = 0;
  var perVariantPriceCents = 0;
  var productIsEligible = false;

  var FALLBACK_ELIGIBLE_HANDLES = [
    'luxe-chiffon-fabric-swatches',
    'luxe-satin-fabric-swatches',
    'satin-fabric-swatches',
    'velvet-fabric-swatches'
  ];
  var FALLBACK_THRESHOLD = 3;

  function getEligibleHandles() {
    var bar = document.querySelector('.kb-free-swatches-bar');
    if (bar && bar.dataset.handles) {
      var list = (bar.dataset.handles || '')
        .split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean);
      if (list.length) return list;
    }
    return FALLBACK_ELIGIBLE_HANDLES.slice();
  }
  function getThreshold() {
    var bar = document.querySelector('.kb-free-swatches-bar');
    if (bar) {
      var t = parseInt(bar.dataset.threshold, 10);
      if (!isNaN(t)) return t;
    }
    return FALLBACK_THRESHOLD;
  }

  function init() {
    document.addEventListener('click', onTriggerClick, true);
    decorateSwatchCards();
    observeGridForCards();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function onTriggerClick(e) {
    var trigger = e.target.closest('[data-kb-quickview]');
    if (!trigger) return;
    var href = trigger.getAttribute('href') || trigger.getAttribute('data-href') || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    lastTrigger = trigger;
    openQuickview(m[1]);
  }

  function decorateSwatchCards() {
    if (!document.body.classList.contains('template-collection')) return;
    var handles = getEligibleHandles();
    if (!handles.length) return;

    var cardSelectors = '.bc-sf-filter-product-item, .product-item, .product-card';
    document.querySelectorAll(cardSelectors).forEach(function (card) {
      if (card.dataset.kbQvDecorated === '1') return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = m[1].toLowerCase();
      if (handles.indexOf(handle) < 0) return;

      var btn = document.createElement('a');
      btn.className = 'kb-qv-card-btn';
      btn.href = link.getAttribute('href');
      btn.setAttribute('data-kb-quickview', '1');
      btn.textContent = 'Quick View';
      card.appendChild(btn);
      card.dataset.kbQvDecorated = '1';
    });
  }
  function observeGridForCards() {
    if (!document.body.classList.contains('template-collection')) return;
    var grid = document.querySelector('#bc-sf-filter-products, .bc-sf-filter-products, .collection .products, .product-grid');
    var target = grid || document.body;
    var obs = new MutationObserver(function () { decorateSwatchCards(); });
    obs.observe(target, { childList: true, subtree: true });
  }

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.id = MODAL_ID;
    modalEl.className = 'kb-qv';
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="kb-qv__backdrop" data-kb-qv-close></div>' +
      '<div class="kb-qv__dialog" role="dialog" aria-modal="true" aria-labelledby="kb-qv-title">' +
        '<button type="button" class="kb-qv__close" data-kb-qv-close aria-label="Close">&times;</button>' +
        '<div class="kb-qv__body">' +
          '<div class="kb-qv__media">' +
            '<img class="kb-qv__image" alt="" />' +
          '</div>' +
          '<div class="kb-qv__info">' +
            '<div class="kb-qv__header">' +
              '<h2 class="kb-qv__title" id="kb-qv-title"></h2>' +
              '<div class="kb-qv__price"></div>' +
            '</div>' +
            '<div class="kb-qv__option-wrap">' +
              '<div class="kb-qv__option-label-row">' +
                '<span class="kb-qv__option-label">Color</span>' +
                '<span class="kb-qv__selected-summary"></span>' +
              '</div>' +
              '<div class="kb-qv__color-picker">' +
                '<button type="button" class="kb-qv__picker-toggle" aria-expanded="false">' +
                  '<span class="kb-qv__picker-summary">Select colors by name</span>' +
                  '<span class="kb-qv__picker-chevron" aria-hidden="true"></span>' +
                '</button>' +
                '<div class="kb-qv__picker-panel" hidden>' +
                  '<div class="kb-qv__picker-list"></div>' +
                '</div>' +
              '</div>' +
              '<div class="kb-qv__chips"></div>' +
            '</div>' +
            '<div class="kb-qv__loading">Loading…</div>' +
            '<div class="kb-qv__error" hidden>We couldn\'t load this product. Open the full page.</div>' +
            '<button type="button" class="kb-qv__atc" disabled>Select Color</button>' +
            '<a class="kb-qv__fulldetails" href="#">View full details</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modalEl);

    modalEl.addEventListener('click', function (e) {
      if (e.target.matches('[data-kb-qv-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.classList.contains('is-open')) closeModal();
    });

    var atcBtn = modalEl.querySelector('.kb-qv__atc');
    atcBtn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      handleAddToCart();
    }, true);

    modalEl.querySelector('.kb-qv__chips').addEventListener('click', function (e) {
      var chip = e.target.closest('.kb-qv__chip');
      if (!chip || chip.disabled) return;
      toggleByValue(chip.dataset.value);
    });

    // Toggle the checkbox dropdown panel
    var toggleBtn = modalEl.querySelector('.kb-qv__picker-toggle');
    var panelEl = modalEl.querySelector('.kb-qv__picker-panel');
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var nowOpen = panelEl.hasAttribute('hidden');
      if (nowOpen) { panelEl.removeAttribute('hidden'); toggleBtn.setAttribute('aria-expanded', 'true'); }
      else { panelEl.setAttribute('hidden', ''); toggleBtn.setAttribute('aria-expanded', 'false'); }
    });
    // Click inside panel: handle checkbox changes; clicks outside the picker close it
    panelEl.addEventListener('click', function (e) {
      var item = e.target.closest('.kb-qv__picker-item');
      if (!item) return;
      if (item.classList.contains('is-oos')) return;
      e.preventDefault();
      toggleByValue(item.dataset.value);
    });
    document.addEventListener('click', function (e) {
      if (!modalEl.classList.contains('is-open')) return;
      if (e.target.closest('.kb-qv__color-picker')) return;
      panelEl.setAttribute('hidden', '');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });

    return modalEl;
  }

  function openQuickview(handle) {
    ensureModal();
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    setLoading(true);
    setError(false);
    currentProduct = null;
    lastClickedVariant = null;
    selectedVariantIds = [];
    underThreshold = false;
    thresholdValue = getThreshold();
    cartEligibleCount = 0;
    perVariantPriceCents = 0;
    productIsEligible = false;

    modalEl.querySelector('.kb-qv__title').textContent = '';
    modalEl.querySelector('.kb-qv__price').textContent = '';
    modalEl.querySelector('.kb-qv__chips').innerHTML = '';
    modalEl.querySelector('.kb-qv__picker-list').innerHTML = '';
    modalEl.querySelector('.kb-qv__selected-summary').textContent = '';
    modalEl.querySelector('.kb-qv__picker-summary').textContent = 'Select colors by name';
    modalEl.querySelector('.kb-qv__picker-panel').setAttribute('hidden', '');
    modalEl.querySelector('.kb-qv__picker-toggle').setAttribute('aria-expanded', 'false');
    modalEl.querySelector('.kb-qv__image').src = '';
    modalEl.querySelector('.kb-qv__atc').disabled = true;
    modalEl.querySelector('.kb-qv__atc').textContent = 'Select Color';
    modalEl.querySelector('.kb-qv__fulldetails').setAttribute('href', '/products/' + handle);

    Promise.all([
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      }),
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { items: [] }; }).catch(function () { return { items: [] }; })
    ])
      .then(function (results) {
        var product = results[0];
        var cart = results[1];

        var eligibleHandles = getEligibleHandles();
        productIsEligible = eligibleHandles.indexOf(handle.toLowerCase()) >= 0;
        cartEligibleCount = 0;
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            var h = (item.handle || '').toLowerCase();
            if (eligibleHandles.indexOf(h) >= 0) cartEligibleCount += item.quantity;
          });
        }
        underThreshold = productIsEligible && cartEligibleCount < thresholdValue;

        renderProduct(product);
      })
      .catch(function () { setLoading(false); setError(true); });
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) try { lastTrigger.focus(); } catch (e) {}
  }

  function setLoading(on) { if (modalEl) modalEl.querySelector('.kb-qv__loading').hidden = !on; }
  function setError(on) { if (modalEl) modalEl.querySelector('.kb-qv__error').hidden = !on; }

  function renderProduct(product) {
    currentProduct = product;
    setLoading(false);
    setError(false);

    perVariantPriceCents = (product.variants && product.variants[0] && product.variants[0].price) || 0;

    modalEl.querySelector('.kb-qv__title').textContent = product.title || '';

    var firstOption = product.options && product.options[0];
    var chips = modalEl.querySelector('.kb-qv__chips');
    var pickerList = modalEl.querySelector('.kb-qv__picker-list');
    chips.innerHTML = '';
    pickerList.innerHTML = '';

    var variantsByValue = {};
    (product.variants || []).forEach(function (v) { variantsByValue[v.option1] = v; });

    ((firstOption && firstOption.values) || []).forEach(function (value) {
      var v = variantsByValue[value];
      var isOOS = !v || !v.available;
      var imageSrc = v && v.featured_image && v.featured_image.src;

      // Chip in the grid
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'kb-qv__chip';
      chip.dataset.value = value;
      chip.dataset.variantId = v ? String(v.id) : '';
      chip.setAttribute('aria-label', value);
      chip.title = value + (isOOS ? ' (Out of stock)' : '');
      if (isOOS) { chip.classList.add('is-oos'); chip.disabled = true; }
      if (imageSrc) chip.style.backgroundImage = "url('" + imageSrc + "')";
      chips.appendChild(chip);

      // Row in the checkbox dropdown
      var item = document.createElement('div');
      item.className = 'kb-qv__picker-item';
      item.dataset.value = value;
      item.dataset.variantId = v ? String(v.id) : '';
      if (isOOS) item.classList.add('is-oos');
      var swatch = '<span class="kb-qv__picker-swatch"' + (imageSrc ? ' style="background-image:url(\'' + imageSrc + '\')"' : '') + '></span>';
      item.innerHTML =
        '<span class="kb-qv__picker-check" aria-hidden="true"></span>' +
        swatch +
        '<span class="kb-qv__picker-name">' + value + (isOOS ? ' — out of stock' : '') + '</span>';
      pickerList.appendChild(item);
    });

    var imgEl = modalEl.querySelector('.kb-qv__image');
    var src = product.featured_image || '';
    if (src) { imgEl.src = src; imgEl.alt = product.title; }

    updateDisplay();
  }

  function toggleByValue(value) {
    if (!currentProduct) return;
    var v = (currentProduct.variants || []).find(function (x) { return x.option1 === value; });
    if (!v || !v.available) return;

    var idx = selectedVariantIds.indexOf(v.id);
    if (idx >= 0) {
      selectedVariantIds.splice(idx, 1);
    } else {
      selectedVariantIds.push(v.id);
      lastClickedVariant = v;
      var imgEl = modalEl.querySelector('.kb-qv__image');
      if (v.featured_image && v.featured_image.src) {
        imgEl.src = v.featured_image.src;
        imgEl.alt = (currentProduct.title || '') + ' — ' + v.option1;
      }
      modalEl.querySelector('.kb-qv__fulldetails').setAttribute('href',
        '/products/' + currentProduct.handle + '?variant=' + v.id);
    }
    // Sync visual state across both surfaces
    var isSelected = selectedVariantIds.indexOf(v.id) >= 0;
    modalEl.querySelectorAll('.kb-qv__chip[data-value="' + cssEscape(value) + '"]').forEach(function (el) {
      el.classList.toggle('is-selected', isSelected);
    });
    modalEl.querySelectorAll('.kb-qv__picker-item[data-value="' + cssEscape(value) + '"]').forEach(function (el) {
      el.classList.toggle('is-selected', isSelected);
    });
    updateDisplay();
  }

  function cssEscape(s) { return (s || '').replace(/"/g, '\\"'); }

  function updateDisplay() {
    var count = selectedVariantIds.length;
    var remaining = Math.max(0, thresholdValue - cartEligibleCount);

    // v8.9.16.4: Price area with optional "Get N free swatches" hint
    var priceEl = modalEl.querySelector('.kb-qv__price');
    var perLabel = formatPrice(perVariantPriceCents);
    if (productIsEligible && remaining > 0) {
      var noun = remaining === 1 ? 'swatch' : 'swatches';
      priceEl.innerHTML =
        '<span class="kb-qv__price-strike">' + perLabel + '</span>' +
        ' <span class="kb-qv__price-free">$0.00</span>' +
        ' <span class="kb-qv__price-msg">— Get ' + remaining + ' free ' + noun + '</span>';
    } else {
      priceEl.innerHTML = '<span class="kb-qv__price-regular">' + perLabel + '</span>';
    }

    // Selected summary (small text next to "Color" label)
    var summaryEl = modalEl.querySelector('.kb-qv__selected-summary');
    var pickerSummaryEl = modalEl.querySelector('.kb-qv__picker-summary');
    if (count === 0) {
      summaryEl.textContent = '';
      summaryEl.classList.remove('has-selection');
      pickerSummaryEl.textContent = 'Select colors by name';
    } else {
      var names = selectedVariantIds.map(function (id) {
        var v = (currentProduct.variants || []).find(function (x) { return x.id === id; });
        return v ? v.option1 : '';
      }).filter(Boolean);
      var shown = names.slice(0, 2).join(', ');
      var more = names.length > 2 ? ' + ' + (names.length - 2) + ' more' : '';
      summaryEl.textContent = count + ' selected';
      summaryEl.classList.add('has-selection');
      pickerSummaryEl.textContent = count + ' selected · ' + shown + more;
    }

    // ATC label + total
    var atc = modalEl.querySelector('.kb-qv__atc');
    if (count === 0) {
      atc.disabled = true;
      atc.textContent = 'Select Color';
      return;
    }
    atc.disabled = false;
    if (productIsEligible) {
      var freeSlots = Math.max(0, thresholdValue - cartEligibleCount);
      var freeCount = Math.min(count, freeSlots);
      var paidCount = count - freeCount;
      var paidCents = paidCount * perVariantPriceCents;
      var totalLabel = paidCents === 0 ? 'Free' : formatPrice(paidCents);
      atc.textContent = 'Add ' + count + ' to Bag — ' + totalLabel;
    } else {
      var totalCents = count * perVariantPriceCents;
      atc.textContent = 'Add ' + count + ' to Bag — ' + formatPrice(totalCents);
    }
  }

  function formatPrice(cents) { return '$' + (cents / 100).toFixed(2); }

  function handleAddToCart() {
    if (selectedVariantIds.length === 0) return;
    var atc = modalEl.querySelector('.kb-qv__atc');
    var originalLabel = atc.textContent;
    atc.disabled = true;
    atc.textContent = 'Adding…';

    var items = selectedVariantIds.map(function (id) { return { id: id, quantity: 1 }; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('atc ' + r.status); return r.json(); })
      .then(function () {
        atc.textContent = 'Added ' + selectedVariantIds.length + ' ✓';
        setTimeout(function () { closeModal(); }, 850);
      })
      .catch(function () {
        atc.disabled = false;
        atc.textContent = originalLabel;
        alert('Could not add to bag. Please try again or open the full product page.');
      });
  }
})();
